<template>
    <div class="container">
        <div v-if="fetchingPricingItems" class="xl:grid grid-cols-4 justify-center items-center space-y-4 xl:gap-x-4">
            <AppSkeletonPricing v-for="(item, index) in 4" :key="index" size="lg" />
        </div>
        <div v-else>
            <div class="xl:flex justify-between items-center">
                <PlansCardsTitle />
                <PlansCardsTabs />
            </div>
            <PlansCardsList />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useUserStore } from "~/store/global/user.store";
import { usePricingSubscribe } from "../../store/usePricingSubscribe";

const { fetchingPricingItems, currentCurrency, pricingCardsDataYearly, pricingCardsDataMonthly } = storeToRefs(
    usePricingStore()
);

const store = usePricingStore();
currentCurrency.value = store.initialCurrency();
await store.fetchPricingPlansData();
const { isUserLoggedIn, userData } = storeToRefs(useUserStore());
const { handleSubscribe, tempSubscribePayload } = usePricingSubscribe();

watch(isUserLoggedIn, async () => {
    currentCurrency.value = store.initialCurrency();
    fetchingPricingItems.value = true;
    pricingCardsDataMonthly.value = [];
    pricingCardsDataYearly.value = [];
    if (tempSubscribePayload.value && userData.value.free_plan) {
        handleSubscribe();
    }
    await usePricingStore().fetchPricingPlansData();
});

onBeforeUnmount(() => {
    clearNuxtState(["tempSubscribePayload"]);
});
</script>
